import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    briefsTareas: [],

    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    /* Filtro */
    filtroPeriodo: true,
    filtroBrief: false,
    filtroPresupuesto: false,
    fechaDesde: moment(new Date()).add(-365, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,
    presupuestoInterno: null,
    presupuestoNumero: 0,
    briefId: 0,
    prioridad: null,
    estado: null,
    usuario: null,
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.briefsTareas = [];

        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.filtroPeriodo = true;
        state.filtroBrief = false;
        state.filtroPresupuesto = false;
        state.fechaDesde = moment(new Date()).add(-365, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.cliente = null;
        state.presupuestoInterno = null;
        state.presupuestoNumero = 0;
        state.briefId = 0;
        state.prioridad = null;
        state.estado = null;
        state.usuario = null;
     },

    'INICIALIZAR_BRIEFS_TAREAS' (state) {
        state.briefsTareas = [];
    },
    'SET_BRIEFS_TAREAS' (state, briefsTareas) {
        state.briefsTareas = briefsTareas.map(tarea => ({
            ...tarea,
            briefTareaEstadoFontColor: getContrastingTextColor(tarea.briefTareaEstadoColor),
            _showDetails: false,   
        }))
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
    'SHOW_DETAILS_BRIEF_TAREA'(state, briefTareaId) {
        let tarea;

        if (state.briefsTareas) {
            tarea = state.briefsTareas.find(t => t.id == briefTareaId);
        }

        if (tarea) {
            tarea._showDetails = !tarea._showDetails;
        }
    },    
};

function getContrastingTextColor(hexColor) {
    // Quita el símbolo # si está
    hexColor = hexColor.replace('#', '');

    // Parsea los valores R, G y B
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);

    // Calcula la luminancia
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Retorna negro o blanco según la luminancia
    return luminance > 140 ? '#23282c' : '#FFFFFF';
}

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getBriefsTareas ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BRIEFS_TAREAS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if ((/true/i).test(state.filtroBrief)) {
                if (state.briefId != 0) {
                    queryString += '&briefId=' + state.briefId;
                } else {
                    queryString += '&briefId=-1';
                }
            } else if ((/true/i).test(state.filtroPresupuesto)) {
                if (state.presupuestoNumero != 0) {
                    queryString += '&presupuestoNumero=' + state.presupuestoNumero;
                } else {
                    queryString += '&presupuestoNumero=-1';
                }
            } else {
                queryString += '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');

                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += (queryString == '' ? '?' : '&') + 'clienteId=' + state.cliente.id;
                    }
                }
                if (state.presupuestoInterno) {
                    if (state.presupuestoInterno.id != 0) {
                        queryString += (queryString == '' ? '?' : '&') + 'presupuestoInternoId=' + state.presupuestoInterno.id;
                    }
                }
                if (state.prioridad) {
                    if (state.prioridad.id != 0) {
                        queryString += (queryString == '' ? '?' : '&') + 'prioridadId=' + state.prioridad.id;
                    }
                }
                if (state.estado) {
                    if (state.estado.id != 0) {
                        queryString += (queryString == '' ? '?' : '&') + 'estadoId=' + state.estado.id;
                    }
                }
                if (state.usuario) {
                    if (state.usuario.id != 0) {
                        queryString += (queryString == '' ? '?' : '&') + 'usuarioId=' + state.usuario.id;
                    }
                }
            }

            /* Recuperamos únicamente el dashboard propio */
            apiAxios.get('briefs/tareas' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_BRIEFS_TAREAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    showDetailsTarea ( { commit }, briefTareaId ) {
        return new Promise((resolve, reject) => {
            commit('SHOW_DETAILS_BRIEF_TAREA', briefTareaId);
            resolve();
        })
    },        
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}